import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { dayAsIso, plusDays } from "../../../lib/initialAssessmentAdmin";

/**
 * A question before sending or reopening, with the deadline the team may
 * change. `question(dayIso, unchanged)` words it for the day picked; on
 * confirm, `onConfirm(day)` gets the day only if it was changed — the server
 * then keeps its own deadline, which is what the question said.
 */
export default function DeadlineDialog({ open, title, question, note, initialDay, confirmLabel, busy, onConfirm, onClose,
  withDate = true }) {
  const [day, setDay] = useState(initialDay || "");
  useEffect(() => { if (open) setDay(initialDay || ""); }, [open, initialDay]);
  const unchanged = day === initialDay;
  const valid = !withDate || Boolean(day);

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && !busy) onClose(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{question(dayAsIso(day), unchanged)}</DialogDescription>
        </DialogHeader>
        {note && <p className="text-sm text-[#8a6a1a]" data-testid="assessment-dialog-note">{note}</p>}
        {withDate && (
          <label className="grid gap-1 text-sm text-[#373A45]">
            <span className="text-xs font-semibold uppercase tracking-widest text-[#6B7280]">Termen</span>
            <input type="date" value={day} min={plusDays(1)} onChange={(e) => setDay(e.target.value)}
              className="w-48 rounded-lg border border-[#E5E7EB] px-2.5 py-1.5 outline-none focus:ring-2 focus:ring-[#965EA7]"
              data-testid="assessment-dialog-deadline" />
          </label>
        )}
        <DialogFooter>
          <button type="button" disabled={busy} onClick={onClose}
            className="rounded-full border border-[#E5E7EB] px-4 py-2 text-sm font-semibold text-[#373A45] hover:bg-[#F5F6F6]">
            Renunță
          </button>
          <button type="button" disabled={busy || !valid} onClick={() => onConfirm(withDate && !unchanged ? day : null)}
            className="inline-flex items-center gap-1.5 rounded-full bg-[#965EA7] px-4 py-2 text-sm font-semibold text-white hover:bg-[#7A4986] disabled:opacity-50"
            data-testid="assessment-dialog-confirm">
            {busy && <Loader2 className="animate-spin" size={14} />} {confirmLabel}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
